import request from '../request'
import apis from '../apis'

export default {

    /**
     * 获取酒店资源列表数据
     * @param {*} pageVO
     * @param {*} params
     */
    findBookingHotelPageList({ pageVO, params }) {
        return request.get(`${apis.GET_HOTEL_RESOURCES_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    }
}
